<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" ref="searchform">
						<el-form-item :label="$t('goods.product')" prop="goods_id">
							<el-select v-model="formInline.goods_id" :placeholder="$t('goods.select_product')" clearable
								style="width: 200px;">
								<el-option :label="$t('goods.all')" value=""></el-option>
								<el-option v-for="item in goodsType" :key="item.id" :label="item.title"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('goods.category_label')" prop="category_id">
							<el-select v-model="formInline.category_id" :placeholder="$t('goods.select_category')" clearable
								style="width: 200px;">
								<el-option :label="$t('goods.all')" value=""></el-option>
								<el-option v-for="item in categories" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<!-- 添加状态筛选 -->
						<el-form-item :label="$t('goods.status_label')" prop="status">
							<el-select v-model="formInline.status" :placeholder="$t('goods.select_status')" clearable style="width: 200px;">
								<el-option :label="$t('goods.all')" value=""></el-option>
								<el-option :label="$t('goods.status_pending')" :value="1"></el-option>
								<el-option :label="$t('goods.status_published')" :value="2"></el-option>
								<el-option :label="$t('goods.status_offline')" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('goods.title')" prop="title">
							<el-input :placeholder="$t('goods.input_title')" v-model="formInline.title"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button @click="seachFun" type="primary">{{ $t('device.inquire')  }}</el-button>
							<el-button @click="resetForm" type="primary">{{ $t('device.reset')  }}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-button @click="addUser" type="primary">
					{{ $t('device.add')  }}
				</el-button>
			</template>
			<el-table :data="appData" :default-sort="{prop: 'date', order: 'descending'}" border stripe
				style="width: 100%">
				<el-table-column label="ID" prop="id" width="90"></el-table-column>
				<el-table-column :label="$t('goods.name')" prop="goods_name" width="150"></el-table-column>
				<el-table-column :label="$t('goods.category_label')" prop="category_name" width="120"></el-table-column>
				<el-table-column :label="$t('goods.title')" prop="title" width="550"></el-table-column>
				<el-table-column :label="$t('goods.rank_label')" prop="rank" width="180"></el-table-column>
				<!-- 添加状态列 -->
				<el-table-column :label="$t('goods.status_label')" prop="status" width="120">
					<template #default="scope">
						<el-tag 
							:type="scope.row.status == 2 ? 'success' : scope.row.status == 1 ? 'warning' : 'info'"
							size="small"
						>
							{{ formatStatus(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column :label="$t('goods.create_time')" prop="create_at" width="180"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="280">
					<template #default="scope">
						<el-button @click="handleEdit(scope.row)" type="primary" size="small">{{ $t('goods.edit')  }}
						</el-button>
						<el-button @click="handleDelete(scope.row)" type="danger" size="small">{{ $t('goods.delete')  }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50, 200]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" fixed="right"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>

			<el-dialog center :title="$t('goods.add_edit')" v-model="addPop" width="50%" class="message-dialog">
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<el-form-item :label="$t('goods.product')" label-width="120px" prop="goods_id" required>
						<el-select v-model="addForm.goods_id" :placeholder="$t('goods.select_product')" clearable style="width: 200px;">
							<el-option v-for="item in goodsType" :key="item.id" :label="item.title"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('goods.category_label')" label-width="120px" prop="category_id" required>
						<el-select v-model="addForm.category_id" :placeholder="$t('goods.select_category')" clearable style="width: 200px;">
							<el-option v-for="item in categories" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('goods.title')" label-width="120px" prop="title">
						<el-input v-model="addForm.title" :placeholder="$t('goods.input_title')"></el-input>
					</el-form-item>
					<el-form-item :label="$t('goods.content')" label-width="120px" prop="content">
						<div class="editor-container">
							<QuillEditor ref="quillEditor" v-model:content="addForm.content" content-type="html"
								:options="editorOption" class="quill-editor" @update:content="handleEditorChange" />
						</div>
					</el-form-item>
					<el-form-item :label="$t('goods.rank')" label-width="120px" prop="rank">
						<el-input v-model="addForm.rank" style="width: 150px;" :placeholder="$t('goods.rank_placeholder')"></el-input>
					</el-form-item>
					<!-- 添加状态字段 -->
					<el-form-item :label="$t('goods.status_label')" label-width="120px" prop="status" style="width:100px;">
						<el-select v-model="addForm.status" :placeholder="$t('goods.select_status')" >
							<el-option :label="$t('goods.status_pending')" :value="1"></el-option>
							<el-option :label="$t('goods.status_published')" :value="2"></el-option>
							<el-option :label="$t('goods.status_offline')" :value="3"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="addPop = false">{{ $t('device.cancel')  }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm')  }}</el-button>
					</span>
				</template>
			</el-dialog>
			
			<!-- 视频上传对话框 -->
			<el-dialog v-model="videoUploadDialog" :title="$t('goods.upload_video')" width="500px">
				<div class="video-upload-dialog">
					<el-upload
						class="video-uploader"
						:action="uploadAction"
						:show-file-list="false"
						:on-success="handleVideoUploadSuccess"
						:on-error="handleVideoUploadError"
						:before-upload="beforeVideoUpload"
						:headers="uploadHeaders"
						:data="uploadData"
						accept="video/*,.mp4,.avi,.mov,.wmv,.flv,.mkv"
					>
						<div class="upload-area">
							<el-button type="primary" :loading="videoUploading">{{ $t('goods.select_video') }}</el-button>
							<div class="el-upload__tip">
								{{ $t('goods.video_format_tip') }}
							</div>
						</div>
					</el-upload>
					
					<!-- 上传进度显示 -->
					<div v-if="uploadProgress > 0 && uploadProgress < 100" style="margin-top: 20px;">
						<el-progress 
							:percentage="uploadProgress" 
							:status="uploadProgress === 100 ? 'success' : undefined"
						></el-progress>
						<div style="text-align: center; margin-top: 10px; color: #666;">
							{{ $t('goods.uploading') }} {{ uploadProgress }}%
						</div>
					</div>
					
					<!-- 视频预览 -->
					<div v-if="videoPreviewUrl" class="video-preview" style="margin-top: 20px;">
						<div style="font-size: 14px; color: #666; margin-bottom: 10px;">{{ $t('goods.video_preview') }}</div>
						<video 
							:src="videoPreviewUrl" 
							controls 
							style="width: 100%; max-height: 200px; border-radius: 4px;"
						></video>
						<div style="margin-top: 15px; text-align: center;">
							<el-button 
								type="primary" 
								size="small" 
								@click="insertVideoToEditor"
							>
								{{ $t('goods.insert_to_editor') }}
							</el-button>
							<el-button 
								size="small" 
								@click="videoPreviewUrl = ''; uploadProgress = 0;"
								style="margin-left: 10px;"
							>
								{{ $t('goods.reupload') }}
							</el-button>
						</div>
					</div>
				</div>
			</el-dialog>
			
			<!-- 图片上传组件 -->
			<input ref="imageInput" type="file" accept="image/*" style="display: none;" @change="handleImageSelect">
		</el-card>
	</div>
</template>

<script>
	import goods from '@/model/goods'
	import goodsHelp from '@/model/goodsHelp'
	import { QuillEditor } from '@vueup/vue-quill'
	import '@vueup/vue-quill/dist/vue-quill.snow.css';

	export default {
		name: "goodsHelp",
		components: {
			QuillEditor
		},
		data() {
			return {
				loadings: false,
				dialogFormVisible: false,
				videoUploadDialog: false,
				videoUploading: false,
				uploadProgress: 0,
				videoPreviewUrl: '',
				uploadedVideoUrl: '',
				uploadAction: '/common/upload',
				uploadHeaders: {
					// 如果需要token认证，可以在这里添加
					// 'Authorization': `Bearer ${localStorage.getItem('token')}`
				},
				uploadData: {},
				imageUploading: false,
				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'],
								[{ 'color': ['#000000', '#FF0000', '#616161', '#9E9E9E', '#E0E0E0', '#2F5496',
									'#D7D31', '#52C41A', '#FAAD14', '#A5A5A5', '#FF4D4F'] }],
								[{ header: 1 }, { header: 2 }],
								[{ list: 'ordered' }, { list: 'bullet' }],
								[{ script: 'sub' }, { script: 'super' }],
								[{ indent: '-1' }, { indent: '+1' }],
								[{ direction: 'rtl' }],
								[{ header: [1, 2, 3, 4, 5, 6, false] }],
								[{ 'size': ['small', false, 'large', 'huge'] }],
								['image', 'video'] // 包含视频按钮
							],
							handlers: {
								'video': this.handleVideoButtonClick,
								'image': this.handleImageButtonClick // 优化图片上传
							}
						}
					},
					placeholder: this.$t('goods.input_content')
				},
				formInline: {
					goods_id: "",
					category_id: "",
					title: "",
					status: "", // 添加状态筛选字段
					page: 1,
					size: 20
				},
				categories: [],
				listCount: 0,
				appData: [],
				addPop: false,
				addForm: {
					id: "",
					goods_id: "",
					category_id: "",
					title: "",
					content: "",
					rank: 100,
					status: 1, // 默认状态为待发布
				},
				goodsType: [],
				rules: {
					goods_id: [{
						required: true,
						message: this.$t('goods.select_product_required'),
						trigger: "change"
					}],
					category_id: [{
						required: true,
						message: this.$t('goods.select_category_required'),
						trigger: "change"
					}],
					title: [{
						required: true,
						message: this.$t('goods.content_required'),
						trigger: "blur"
					}],
					content: [{
						required: true,
						message: this.$t('goods.content_required'),
						trigger: "blur"
					}],
					status: [{ // 添加状态验证规则
						required: true,
						message: this.$t('goods.select_status_required'),
						trigger: "change"
					}],
				}
			};
		},
		async mounted() {
			await this.getGoods();
			this.getGoodsHelp();
			
			// 设置上传请求头，如果有token
			const token = localStorage.getItem('token') || this.$store?.state?.user?.token;
			if (token) {
				this.uploadHeaders.Authorization = `Bearer ${token}`;
			}
		},
		methods: {
			handleEditorChange(content) {
				this.addForm.content = content;
			},
			
			// 格式化状态显示
			formatStatus(status) {
				const statusMap = {
					1: this.$t('goods.status_pending'),
					2: this.$t('goods.status_published'), 
					3: this.$t('goods.status_offline')
				};
				return statusMap[status] || this.$t('goods.unknown_status');
			},
			
			resetForm() {
				this.formInline.goods_id = '';
				this.formInline.category_id = '';
				this.formInline.title = '';
				this.formInline.status = ''; // 重置状态筛选
				this.formInline.page = 1;
				this.getGoodsHelp();
			},
			
			async getGoodsHelp() {
				try {
					const params = {
						goods_id: this.formInline.goods_id,
						category_id: this.formInline.category_id,
						title: this.formInline.title,
						status: this.formInline.status, // 添加状态参数
						page: this.formInline.page,
						size: this.formInline.size,
					};
					const res = await goodsHelp.lists(params);
					if (res.code === 200) {
						this.categories = res.data.category;
						this.appData = (res.data.list || []).map(item => {
							// 根据category_id查找对应的类别名称
							const category = this.categories.find(cat => cat.id === item.category_id);
							return {
								...item,
								category_name: category ? category.name : this.$t('goods.unknown_category')
							};
						});
						this.listCount = res.data.total || 0;
					} else {
						this.$message.error(res.message || this.$t('goods.get_data_failed'));
					}
				} catch (error) {
					this.$message.error(this.$t('goods.get_data_failed') + ': ' + error.message);
				}
			},
			
			async getGoods() {
				try {
					const params = {
						page: 1,
						size: 100,
					};
					const res = await goods.lists(params);
					if (res.code === 200 && res.data && res.data.list) {
						this.goodsType = res.data.list.map(item => ({
							id: item.id,
							title: item.title || item.name || `${this.$t('goods.product')}${item.id}`
						}));
					} else {
						this.goodsType = [];
						this.$message.error(this.$t('goods.get_goods_failed'));
					}
				} catch (error) {
					this.$message.error(this.$t('goods.get_goods_failed') + ': ' + error.message);
				}
			},
			
			seachFun() {
				this.formInline.page = 1;
				this.getGoodsHelp();
			},
			
			handleEdit(row) {
				this.addPop = true;
				this.$nextTick(() => {
					this.addForm = {
						id: row.id,
						goods_id: row.goods_id,
						category_id: row.category_id,
						title: row.title,
						content: row.content || '',
						rank: row.rank || 100,
						status: row.status || 1, // 设置状态值
					};
					if (this.$refs.quillEditor) {
						this.$refs.quillEditor.setHTML(row.content || '');
					}
				});
			},
			
			async handleSubmit() {
				this.$refs.addForm.validate(async (valid) => {
					if (valid) {
						try {
							let res = await goodsHelp.operate(this.addForm);
							if (res.code === 200) {
								this.$message.success(this.addForm.id ? this.$t('goods.edit_success') : this.$t('goods.add_success'));
								this.addPop = false;
								this.getGoodsHelp();
							} else {
								this.$message.error(res.message || this.$t('goods.operate_failed'));
							}
						} catch (error) {
							this.$message.error(this.$t('goods.operate_failed') + ': ' + error.message);
						}
					}
				});
			},
			
			async handleDelete(row) {
				this.$confirm(this.$t('goods.confirm_delete'), this.$t('goods.tip'), {
					type: 'warning'
				}).then(async () => {
					const res = await goodsHelp.delete({id:row.id});
					if (res.code === 200) {
						this.$message.success(this.$t('goods.delete_success'));
						this.getGoodsHelp();
					} else {
						this.$message.error(res.message || this.$t('goods.delete_failed'));
					}
				}).catch(() => {});
			},
			
			addUser() {
				this.addPop = true;
				this.$nextTick(() => {
					if (this.$refs.addForm) {
						this.$refs.addForm.resetFields();
					}
					this.addForm = {
						id: "",
						goods_id: "",
						category_id: "",
						title: "",
						content: "",
						rank: 100,
						status: 1, // 设置默认状态为待发布
					};
					if (this.$refs.quillEditor) {
						this.$refs.quillEditor.setHTML('');
					}
				});
			},
			
			handleSizeChange(val) {
				this.formInline.size = val;
				this.formInline.page = 1;
				this.getGoodsHelp();
			},
			
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.getGoodsHelp();
			},
			
			// 视频上传相关方法
			handleVideoButtonClick() {
				this.videoUploadDialog = true;
				this.videoPreviewUrl = '';
				this.uploadedVideoUrl = '';
				this.uploadProgress = 0;
				this.videoUploading = false;
			},
			
			beforeVideoUpload(file) {
				const isVideo = file.type.startsWith('video/') || 
					['.mp4', '.avi', '.mov', '.wmv', '.flv', '.mkv'].some(ext => 
						file.name.toLowerCase().endsWith(ext)
					);
				
				const isLt100M = file.size / 1024 / 1024 < 100;
				
				if (!isVideo) {
					this.$message.error(this.$t('goods.upload_video_only'));
					return false;
				}
				
				if (!isLt100M) {
					this.$message.error(this.$t('goods.video_size_limit'));
					return false;
				}
				
				this.videoUploading = true;
				this.uploadProgress = 0;
				
				const interval = setInterval(() => {
					if (this.uploadProgress < 90) {
						this.uploadProgress += 10;
					}
				}, 300);
				
				this.uploadInterval = interval;
				
				return true;
			},
			
			handleVideoUploadSuccess(response) {
				if (this.uploadInterval) {
					clearInterval(this.uploadInterval);
					this.uploadInterval = null;
				}
				
				this.videoUploading = false;
				this.uploadProgress = 100;
				
				if (response.code === 200) {
					this.uploadedVideoUrl = response.data;
					this.videoPreviewUrl = response.data;
					this.$message.success(this.$t('goods.video_upload_success'));
				} else {
					this.$message.error(response.message || this.$t('goods.upload_failed'));
				}
			},
			
			handleVideoUploadError(err) {
				if (this.uploadInterval) {
					clearInterval(this.uploadInterval);
					this.uploadInterval = null;
				}
				
				this.videoUploading = false;
				this.uploadProgress = 0;
				this.$message.error(this.$t('goods.video_upload_failed') + ': ' + (err.message || this.$t('goods.upload_failed')));
			},
			
			insertVideoToEditor() {
				if (!this.uploadedVideoUrl) {
					this.$message.warning(this.$t('goods.please_upload_video'));
					return;
				}
				
				try {
					const quill = this.$refs.quillEditor.getQuill();
					const range = quill.getSelection();
					const position = range ? range.index : quill.getLength();
					
					quill.insertEmbed(position, 'video', this.uploadedVideoUrl);
					
					this.videoUploadDialog = false;
					this.videoPreviewUrl = '';
					this.uploadedVideoUrl = '';
					this.uploadProgress = 0;
					this.videoUploading = false;
					
					this.$message.success(this.$t('goods.video_inserted'));
				} catch (error) {
					console.error('插入视频失败:', error);
					this.$message.error(this.$t('goods.video_insert_failed'));
				}
			},
			
			// 优化后的图片上传处理方法
			handleImageButtonClick() {
				// 触发隐藏的文件输入框
				this.$refs.imageInput.click();
			},
			
			async handleImageSelect(event) {
				const file = event.target.files[0];
				if (!file) return;
				
				// 重置文件输入框，以便下次可以再次选择同一个文件
				event.target.value = '';
				
				// 检查文件类型和大小
				if (!file.type.startsWith('image/')) {
					this.$message.error(this.$t('goods.image_upload_only'));
					return;
				}
				
				if (file.size > 10 * 1024 * 1024) {
					this.$message.error(this.$t('goods.image_size_limit'));
					return;
				}
				
				this.imageUploading = true;
				
				try {
					const formData = new FormData();
					formData.append('file', file);
					
					// 使用统一的图片上传接口
					const response = await fetch('/common/upload', {
						method: 'POST',
						headers: {
							'Authorization': this.uploadHeaders.Authorization || ''
						},
						body: formData
					});
					
					const result = await response.json();
					
					if (result.code === 200) {
						// 获取编辑器实例
						const quill = this.$refs.quillEditor.getQuill();
						const range = quill.getSelection();
						const position = range ? range.index : quill.getLength();
						
						// 插入图片URL到编辑器
						const imgUrl = result.data;
						quill.insertEmbed(position, 'image', imgUrl);
						
						this.$message.success(this.$t('goods.image_upload_success'));
					} else {
						this.$message.error(result.message || this.$t('goods.image_upload_failed'));
					}
				} catch (error) {
					console.error('图片上传失败:', error);
					this.$message.error(this.$t('goods.image_upload_failed') + ': ' + error.message);
				} finally {
					this.imageUploading = false;
				}
			},
			
			// 可选：清理编辑器中的base64图片，转为URL
			cleanBase64Images(content) {
				if (!content) return content;
				
				// 这里可以添加逻辑来清理base64图片，但更好的做法是在上传时就处理好
				return content;
			}
		},
		
		beforeUnmount() {
			if (this.uploadInterval) {
				clearInterval(this.uploadInterval);
			}
		}
	};
</script>

<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.card-header {
		display: flex;
		align-items: center;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.tag-item {
		background-color: #f0f0f0;
		padding: 5px 10px;
		margin-right: 10px;
		border-radius: 4px;
		display: inline-flex;
		align-items: center;
	}

	.tag-item .el-icon-close {
		margin-left: 8px;
		cursor: pointer;
		color: red;
	}

	.tag-item .el-icon-close:hover {
		color: #666;
	}

	.editor-container {
		width: 100%;
		margin-bottom: 20px;
	}

	/* 使用 ::v-deep 或 :deep() 穿透 scoped 限制 */
	:deep(.ql-container) {
		min-height: 200px !important;
		max-height: 400px;
		overflow-y: auto;
	}

	:deep(.ql-editor) {
		min-height: 200px;
	}
	
	:deep(.ql-editor img) {
		max-width: 100%;
		height: auto;
	}

	.message-dialog {
		max-height: 100vh;
		overflow-y: auto;
	}

	.message-dialog .el-dialog__body {
		padding-bottom: 20px;
	}
	
	/* 视频上传对话框样式 */
	.video-upload-dialog {
		padding: 10px;
	}
	
	.video-uploader {
		width: 100%;
	}
	
	.upload-area {
		padding: 30px 20px;
		text-align: center;
		border: 2px dashed #dcdfe6;
		border-radius: 6px;
		background-color: #fafafa;
	}
	
	.upload-area:hover {
		border-color: #409eff;
	}
	
	.el-upload__tip {
		margin-top: 10px;
		color: #909399;
		font-size: 12px;
	}
	
	.video-preview {
		text-align: center;
	}
	
	/* 编辑器内视频样式 */
	:deep(.ql-video) {
		display: block;
		max-width: 100%;
		height: auto;
		margin: 10px 0;
	}
</style>